import styled from 'styled-components';
import Row from '../../Common/Row';

export const InputRow = styled(Row)`
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;
`;
